// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"654":"component---src-pages-example-js","678":"component---src-pages-index-js","883":"component---src-pages-404-js"}[chunkId] + "-" + {"654":"d075594d50892c482eba","678":"1b76968cc7fba87d1f9a","883":"785a1e0071383b672dce"}[chunkId] + ".js";
};